// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a7b764a","453":"b7bf1400","455":"88b418ed","977":"b6bc849d"}[chunkId] + ".chunk.js";
};